import React from "react";
import Request from './Request'
import Common from './Common';
import {googleMapKey} from  '../variables/apikeys';
import {
    cst_request_parking_status,
} from '../variables/codes_map';

export let google
let directionsService

const Domain = window.location.href.split('/').slice(0, 3).join('/')

const IconBaseUrl = "https://landmark.jesus-app.jp/.well-known/icon/" // `${Domain}/.well-known/icon/`

const googleMapStylePresets = [
    'style=feature:water|element:geometry.fill|color:0xffffff',
    'style=feature:water|element:geometry.stroke|color:0x000000',
    'style=feature:landscape.natural|element:geometry.fill|color:0xffffff',
    'style=feature:landscape.man_made|element:geometry.fill|color:0xffffff',
    'style=feature:landscape.man_made|element:geometry.stroke|color:0x000000',
    'style=feature:poi|element:geometry.fill|color:0xffffff',
    'style=feature:road.highway|saturation:-100|lightness:50',
    'style=feature:poi|element:labels|visibility:off',
    'style=feature:landscape.man_made|element:labels.icon|visibility:off',
    'style=feature:road|element:geometry.stroke|color:0x000000',
]

const styleParamsForOverlay = [
    "style=feature:all|visibility:off",
    "format=png"
]

const polylineColors = [
    "144fc3", // 青
    "4ad61f", // 緑
    "ff8a00" // オレンジ
]

const googleMapScript = (callbackFunctionName="initGMap") =>{
    return new Promise(resolve => {
        window.initGMap = function(){
            google = window.google
            directionsService = new google.maps.DirectionsService;
            // Optionally create a map
            // var directionsDisplay = new google.maps.DirectionsRenderer;
            // var map = new google.maps.Map(document.getElementById('map'));
            // directionsDisplay.setMap(map);
        }
        const src= `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&callback=${callbackFunctionName}`
        const googleMapScript = document.createElement('script')
        googleMapScript.src = src
        googleMapScript.defer = true
        googleMapScript.onload= function(){
            resolve(true)
        }
        document.getElementById("googlemap").appendChild(googleMapScript)
    })
}

const getMarkerString = (coordinate, iconName, position="center") =>{
    const iconUrl = IconBaseUrl + iconName
    const {
        latitude,
        longitude
    } = coordinate
    console.log(iconName)
    if(iconName.match(/^onsite_route_1\.png$/)) {
        return "marker=" 
            + latitude
            + ',' + longitude
            + "|start||"
    } else if(iconName.match(/^park_route_\d+\.png$/)) {
        var route_num = iconName.match(/^park_route_(\d+)\.png$/)[1]
        return "marker="
            + latitude
            + ',' + longitude
            + "|distinate"
            + "|" + route_num + "|"
    } else if(iconName.match(/^park_ng_\d+\.png$/)) {
        var request_parking_status = iconName.match(/^park_ng_(\d+)\.png$/)[1]
        return "marker=" 
            + latitude
            + ',' + longitude
            + "|flagged" +
            + "|" + request_parking_status
            + "|"
    } else {
        return ""
    }
}

const getPathPolylineGmap = async (originCoordinate, destinationCoordinate, colorString="000000") =>{
    const routeResponse = await new Promise(resolve => {
        const url = `/api/route?route_type=walk&project=${originCoordinate.longitude},${originCoordinate.latitude}&parking=${destinationCoordinate.longitude},${destinationCoordinate.latitude}`
        Request.get(url, {}, res => {
            let result = res.Data.data

            var latlngs = [];
            result.forEach((route) => {
                latlngs.push({lat: route['lat'], lng: route['lng']})
                // for(var i = 0; i < route.length; i+=2) {
                //     latlngs.push({lat: route[i], lng: route[i+1]});
                // }
            });
  
            resolve(latlngs)
        }
        , () => {
        }
        , undefined
        , false)
    });

    // console.log(routeResponse)
    let latlngs = routeResponse.map((latlng) => latlng.lat + ',' + latlng.lng).join(' ')
    let line = "line="
        + latlngs
        + "|0x" + colorString
        + "|5|1.0"
    
    return line
}

const createStaticGoogleMap = async (projectCoordinate, checkedParking, ParkingList) => {
    const origin = { 
        latitude: projectCoordinate.latitude,
        longitude: projectCoordinate.longitude
    }
    const checkedUlids = checkedParking.map(checked=>(checked.request_parking&&checked.request_parking.ulid)||checked.keyForRequestParking)
    const flaggedParking = ParkingList.filter((parking)=>{
        return parking.request_parking.route_map_parking_flag == 1 && parking.request_parking.request_parking_status > 1
    }).filter((flagged=>!checkedUlids.includes(flagged.request_parking.ulid)))

    let singleRouteObj = {
        parkings:[],
        routePathsParamString:"",
        statusMarkers:{},
        routeMarkers:[]
    }
    let routeModalData = []
    let routeModalDataIndex = 0
    let PromiseList = []
    
    for (let i=0; i < checkedParking.length; i++){
        const {
            latitude,
            longitude,
            request_parking,
            parking_name,
            survey_site_distance_meter, // for estimate
        } = checkedParking[i]
        const routeNumber = 1 + i
        const parkingCoordinate = {latitude, longitude}
        const polylineColor = polylineColors[parseInt(i%3)]
        const routePathString = await getPathPolylineGmap(origin, parkingCoordinate, polylineColor)
        
        singleRouteObj.parkings.push({
            index:i+1,
            PARKING__parking_name:<div dangerouslySetInnerHTML={{__html:parking_name}} style={{overflow:'hidden'}}/>,
            REQUEST_PARKING__request_parking_status: request_parking && Common.getValueFormDictArray(cst_request_parking_status, request_parking.request_parking_status),
            coordinate: {latitude, longitude},
            routePathString
        })

        singleRouteObj.routeMarkers.push({
            coordinate: parkingCoordinate,
            icon:`park_route_${routeNumber}.png`,
            type:"routeParking",
            align: "center"
        })
        
        if ((i+1)%3==0||i+1==checkedParking.length) {
            const distance = (request_parking?request_parking.site_distance_meter:survey_site_distance_meter)
            singleRouteObj.routeMarkers.push({
                coordinate: origin,
                icon:`onsite_route_1.png`,
                type:"origin",
                align: "center"
            })
            singleRouteObj.routePathsParamString = singleRouteObj.parkings.map(({routePathString})=>routePathString).reverse().join("&")
            const shorterFlaggedParkingMap = flaggedParking.filter(flagged=>
                parseFloat(flagged.request_parking.site_distance_meter)<=parseFloat(distance))
                .reduce((acc, filteredParking)=>{
                    if (acc[filteredParking.request_parking.request_parking_status]){
                        acc[filteredParking.request_parking.request_parking_status].push(filteredParking)
                    } else {
                        acc[filteredParking.request_parking.request_parking_status] = [filteredParking]
                    }
                    return acc
                },{})
            
            for (const request_parking_status in shorterFlaggedParkingMap) {
                const shorterFlaggedParking = shorterFlaggedParkingMap[request_parking_status]
                singleRouteObj.statusMarkers[request_parking_status]=[]
                for(let j=0; j<shorterFlaggedParking.length; j++){
                    const shoterFlagged = shorterFlaggedParking[j]
                    const {
                        latitude,
                        longitude,
                        parking_name
                    } = shoterFlagged
                    const parkingCoordinate = {latitude, longitude}
                    
                    singleRouteObj.statusMarkers[request_parking_status].push({
                        coordinate: parkingCoordinate,
                        icon:`park_ng_${request_parking_status}.png`,
                        type:"statusParking",
                        align: "center"
                    })
                    
                    const statusString = Common.getValueFormDictArray(cst_request_parking_status, request_parking_status)
                    singleRouteObj.parkings.push({
                        index: statusString,
                        PARKING__parking_name:<div dangerouslySetInnerHTML={{__html:parking_name}} style={{overflow:'hidden'}}/>,
                        REQUEST_PARKING__request_parking_status: statusString,
                        coordinate: {latitude, longitude},
                    })
                }
            }
            
            const mapWidth = 640
            const mapHeight = 480
            
            const canvas = document.createElement('canvas')
            const canvasCtx = canvas.getContext('2d');
            
            canvas.width = mapWidth
            canvas.height = mapHeight
            singleRouteObj.canvas = canvas
            // console.log(origin)
            // const baseMapUrl = `https://maps.googleapis.com/maps/api/staticmap?key=${googleMapKey}&size=${mapWidth}x${mapHeight}&scale=1&language=ja` 
            const baseMapUrl = location.protocol + "//" + location.host + `/api/mapimage?size=${mapWidth},${mapHeight}&center=${origin.latitude},${origin.longitude}&zoom=17`

            const {
                firstUrl,
                secondUrl,
                lastUrl
            } = createMapUrlFromRouteObject(baseMapUrl, singleRouteObj)
            // console.log(firstUrl)
            // console.log(secondUrl)
            // console.log(lastUrl)
            
            PromiseList.push( new Promise( async (resolve, reject)=>
                {
                    try{
                        await loadMap2Canvas(canvasCtx, firstUrl, {top:0, left:0})
                        secondUrl && await loadMap2Canvas(canvasCtx, secondUrl, {top:0, left:0})
                        lastUrl && await loadMap2Canvas(canvasCtx, lastUrl, {top:0, left:0})
                        resolve()
                    }catch(e){
                        reject(e)
                    }
                })
            )

            routeModalData[routeModalDataIndex] = singleRouteObj
            singleRouteObj= {
                parkings:[],
                routePathsParamString:"",
                statusMarkers:{},
                routeMarkers:[]
            }
            routeModalDataIndex++
        }
        await Promise.all(PromiseList).then(r=>r)
        PromiseList = []
        await new Promise(resolve=>{setTimeout(()=>{resolve()}, 1000)})
    }
    await Promise.all(PromiseList).then(r=>r)
    return routeModalData
}

const createStaticMapForUrls = async (urls) => {
//    console.log("createStaticMapForUrls",urls)
    let PromiseList = []
    let returnObjects = []
//    const mapWidth = 640
//    const mapHeight = 480
    const mapWidth = 640
    const mapHeight = 600

    urls.map((url,index) => {
        const canvas = document.createElement('canvas')
        const canvasCtx = canvas.getContext('2d');
        canvas.width = mapWidth;
        canvas.height = mapHeight;
        PromiseList.push(
            new Promise( async (resolve, reject)=> {
                try{
                    await loadMap2Canvas(canvasCtx, url, {top:0, left:0})
                    resolve()
                }catch(e){
                    reject(e)
                }
//                await new Promise(resolve=>{setTimeout(()=>{resolve()}, 500)})
            })
        )
        returnObjects.push({canvas: canvas})
    })
    await Promise.all(PromiseList).then(r=>r)

//    console.log("createStaticMapForUrls finished",returnObjects)

    return returnObjects
}

const createMapUrlFromRouteObject = (baseMapUrl, singleRouteObj, extraStyles=[], zoomedRouteIndex) => {
    let markersUrlParamsWithNull = ""
    const need2 = Object.keys(singleRouteObj.statusMarkers).length>3
    let markersUrlParams = need2 ? ["",""] : [""]

    for (let statusIndex=0; statusIndex<Object.keys(singleRouteObj.statusMarkers).length; statusIndex++){
        const isPassedLimit = statusIndex>3
        const request_parking_status = Object.keys(singleRouteObj.statusMarkers)[statusIndex]
        const markers = singleRouteObj.statusMarkers[request_parking_status]
        markersUrlParams[0]+="&"+markers.map((markerInfo)=>{
            const {
                coordinate,
                align, 
            } = markerInfo
            const icon = isPassedLimit?"null.png":`park_ng_${request_parking_status}.png`
            return getMarkerString(coordinate, icon, align)
        }).join('&')

        if (need2){
            markersUrlParams[1]+="&"+markers.map((markerInfo)=>{
                const {
                    coordinate,
                    align, 
                } = markerInfo
                const icon = isPassedLimit?`park_ng_${request_parking_status}.png`:"null.png"
                return getMarkerString(coordinate, icon, align)
            }).join('&')
        }
        markersUrlParamsWithNull+="&"+markers.map((markerInfo)=>{
            const {
                coordinate,
                align, 
            } = markerInfo
            const icon = "null.png"
            return getMarkerString(coordinate, icon, align)
        }).join('&')
    }
    
    const routeMarkerParam = zoomedRouteIndex !== undefined
    ? [
        getMarkerString(singleRouteObj.routeMarkers[zoomedRouteIndex].coordinate, changeIconNameForZoom(singleRouteObj.routeMarkers[zoomedRouteIndex].icon), singleRouteObj.routeMarkers[zoomedRouteIndex].align),
        getMarkerString(singleRouteObj.routeMarkers[singleRouteObj.routeMarkers.length-1].coordinate, changeIconNameForZoom(singleRouteObj.routeMarkers[singleRouteObj.routeMarkers.length-1].icon), singleRouteObj.routeMarkers[singleRouteObj.routeMarkers.length-1].align)
    ]
    : singleRouteObj.routeMarkers.map((routeMarker)=>{
        const {
            coordinate,
            icon,
            align,
        } = routeMarker
        return getMarkerString(coordinate, icon, align)
    })
    const routeMarkerParamWithNull = singleRouteObj.routeMarkers.map((routeMarker)=>{
        const {
            coordinate,
            align,
        } = routeMarker
        return getMarkerString(coordinate, "null.png", align)
    })
    
    const hasStatusMarker = Object.keys(singleRouteObj.statusMarkers).length > 0

    const firstUrl = baseMapUrl
        + "&" + (
            zoomedRouteIndex === undefined 
            ? singleRouteObj.routePathsParamString 
            : (singleRouteObj.parkings[zoomedRouteIndex].routePathString)
            )
        + "&" + 
        (
            hasStatusMarker
            ? (
                [
                    markersUrlParams[0],
                    ...routeMarkerParamWithNull,
                    ...extraStyles,
                ].join('&')
            ) : (
                [
                    ...routeMarkerParam,
                    ...extraStyles,
                ].join('&')
            )
        )
    
    const secondUrl = (need2)
    ? (
        baseMapUrl
        + "&" + (
            zoomedRouteIndex === undefined 
            ? singleRouteObj.routePathsParamString 
            : (singleRouteObj.parkings[zoomedRouteIndex].routePathString)
            )
        + "&" + [
            markersUrlParams[1],
            ...routeMarkerParamWithNull,
            ...styleParamsForOverlay
        ].join('&')
    ): undefined

    const lastUrl = (hasStatusMarker)
    ? (
        baseMapUrl
        + "&" + (
            zoomedRouteIndex === undefined 
            ? singleRouteObj.routePathsParamString 
            : (singleRouteObj.parkings[zoomedRouteIndex].routePathString)
            )
        + "&" + [
            markersUrlParamsWithNull,
            ...routeMarkerParam,
            ...styleParamsForOverlay
        ].join('&')
    ) : undefined

    return {
        firstUrl,
        secondUrl,
        lastUrl
    }
}

const loadMap2Canvas = (canvasCtx, src, {top,left}) => new Promise((resolve, reject)=>{
    let timeout = setTimeout(()=>reject(), 30000);
    const img = new Image
    img.onload = ()=>{
        clearTimeout(timeout)
        canvasCtx.drawImage(img,top,left)
        resolve()
    }
    img.crossorigin="anonymous"
    img.setAttribute('crossorigin', 'anonymous');
    img.src = src
})

const uploadCanvas = (canvas, gcs_path) => new Promise((resolve, reject)=>{
    const dataURL = canvas.toDataURL('image/jpeg') // type default image/png   compression 0-1 : default 0.92
    const url = "/api/gcs_upload"
    Request.post(url, {
        image_base64: dataURL,
        // folder_id: "",
        gcs_path: gcs_path?gcs_path:'parking_picture'
    }, res => {
        const {
            id,
        } = res.Data
        resolve({
            id,
            url : Domain+'/api/image/'+id
        })
    }, err => reject(err))
})

const changeIconNameForZoom = (url) => {
    return url.replace(/onsite_route_1/g, 'onsite_zoom_1')
    .replace(/park_ng_/g, 'park_zoom_ng_')
    .replace(/park_route_/g, 'park_zoom_')
    .replace(/null/g, 'null_zoom')
}

const uploadZoomedRoute = async (singleRouteObj, coordinate, gcs_path, routeIndex)=>{
    const mapWidth = 640
    const mapHeight = 540
    const zoomLevel = 19
    const {
        latitude,
        longitude
    } = coordinate
    const baseMapUrl = `https://maps.googleapis.com/maps/api/staticmap?key=${googleMapKey}&size=${mapWidth}x${mapHeight}&center=${latitude}, ${longitude}&zoom=${zoomLevel}&scale=2&language=ja` 
    const extraStyle = [
        "style=feature:all|element:geometry.stroke|color:0x000000",
        "style=feature:all|weight:3&style=feature:landscape.man_made|weight:1"
    ]
    
    const {
        firstUrl,
        secondUrl,
        lastUrl
    } = createMapUrlFromRouteObject(baseMapUrl, singleRouteObj, extraStyle, routeIndex)

    const canvas = document.createElement('canvas')
    const canvasCtx = canvas.getContext('2d');
    canvas.width = mapWidth*2
    canvas.height = mapHeight*2
    await loadMap2Canvas(canvasCtx, changeIconNameForZoom(firstUrl), {top:0, left:0})
    secondUrl && await loadMap2Canvas(canvasCtx, changeIconNameForZoom(secondUrl), {top:0, left:0})
    lastUrl && await loadMap2Canvas(canvasCtx, changeIconNameForZoom(lastUrl), {top:0, left:0})

    const fileObject = await uploadCanvas(canvas, gcs_path)
    return fileObject // {id, url}
}

const uploadZoomedRouteMap = async (url, gcs_path) => {
    const mapWidth = 1280
    const mapHeight = 1200
    const canvas = document.createElement('canvas')
    const canvasCtx = canvas.getContext('2d');
    // canvas.width = mapWidth * 2
    // canvas.height = mapHeight * 2
    canvas.width = mapWidth
    canvas.height = mapHeight

    // if(url.length > 8192){
    //     return false;
    // }

    await loadMap2Canvas(canvasCtx, url, {top:0, left:0})
    const fileObject = await uploadCanvas(canvas, gcs_path)
    return fileObject // {id, url}
}

export default {googleMapScript, createStaticGoogleMap,  uploadCanvas, uploadZoomedRoute, createStaticMapForUrls, uploadZoomedRouteMap}